import { ADMIN_ROUTE_NAMES } from 'utils/consts/administrationFilters'
import { Roles } from 'utils/consts/userRoles'
import { MY_REVIEW_ROUTE_NAME } from 'utils/consts/routes/myReviews'
import { myReviewsFiltersName } from './keys'

const defaultReviewFilters = [
  myReviewsFiltersName.producerFilter,
  myReviewsFiltersName.brandFilter,
  myReviewsFiltersName.countryFilter,
  myReviewsFiltersName.euGITypeFilter,
  myReviewsFiltersName.nationalGITypeFilter,
  myReviewsFiltersName.wineRegionEUFilter,
  myReviewsFiltersName.geoIndicationFilter,
  myReviewsFiltersName.specialClassificationFilter,
  myReviewsFiltersName.wineTypeFilter,
  myReviewsFiltersName.wineColourFilter,
  myReviewsFiltersName.sweetnessTypeFilter,
  myReviewsFiltersName.vintageFilter,
  myReviewsFiltersName.bottleSizeFilter,
  myReviewsFiltersName.packageTypeFilter,
  myReviewsFiltersName.grapesFilter,
  myReviewsFiltersName.monocepageFilter,
  myReviewsFiltersName.additionalInfoFilter,
  myReviewsFiltersName.alcoholLevelFilter,
  myReviewsFiltersName.wwlRatingFilter,
  myReviewsFiltersName.samplingDateFilter,
  myReviewsFiltersName.venueTypeFilter,
]

const ADMIN_FILTERS = [
  myReviewsFiltersName.usersFilter,
  myReviewsFiltersName.createdAtFilter,
  myReviewsFiltersName.drinkingWindowFilter,
  myReviewsFiltersName.samplingDateFilter,
  myReviewsFiltersName.producerFilter,
  myReviewsFiltersName.brandFilter,
  myReviewsFiltersName.countryFilter,
  myReviewsFiltersName.euGITypeFilter,
  myReviewsFiltersName.nationalGITypeFilter,
  myReviewsFiltersName.wineRegionEUFilter,
  myReviewsFiltersName.geoIndicationFilter,
  myReviewsFiltersName.specialClassificationFilter,
  myReviewsFiltersName.wineTypeFilter,
  myReviewsFiltersName.wineColourFilter,
  myReviewsFiltersName.sweetnessTypeFilter,
  myReviewsFiltersName.vintageFilter,
  myReviewsFiltersName.bottleSizeFilter,
  myReviewsFiltersName.packageTypeFilter,
  myReviewsFiltersName.grapesFilter,
  myReviewsFiltersName.monocepageFilter,
  myReviewsFiltersName.additionalInfoFilter,
  myReviewsFiltersName.alcoholLevelFilter,
  myReviewsFiltersName.wwlRatingFilter,
  myReviewsFiltersName.recognitionStatusFilter,
  myReviewsFiltersName.statusFilter,
]

export const includedReviewsFiltersOnRoute = {
  [MY_REVIEW_ROUTE_NAME]: {
    default: defaultReviewFilters,
  },
  [ADMIN_ROUTE_NAMES.adminReviews]: {
    [Roles.MANAGER]: ADMIN_FILTERS,
    [Roles.SUPERADMIN]: ADMIN_FILTERS,
    [Roles.CONTENT]: ADMIN_FILTERS,

    default: [],
  },
}
